module.exports = __webpack_public_path__ + "img/endwords.9691b0be.png";